import React, { useCallback, useEffect, useState } from 'react';
import Head from 'next/head';
import {
  AmbassadorDesktopTemplate,
  AmbassadorMobileTemplate,
  HeaderTemplate,
} from '../components';
import { ambassadorLinks } from '../enums';

const useMediaQuery = (width: number) => {
  const [targetReached, setTargetReached] = useState(false);

  const updateTarget = useCallback((e) => {
    if (e.matches) {
      setTargetReached(true);
    } else {
      setTargetReached(false);
    }
  }, []);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${width}px)`);
    media.addListener(updateTarget);

    if (media.matches) {
      setTargetReached(true);
    }

    return () => media.removeListener(updateTarget);
  }, []);

  return targetReached;
};

const AmbassadorPaAge = (): any => {
  const isBreakpoint = useMediaQuery(768);
  return (
    <>
      <Head>
        <title>Doctor Ambassador</title>
      </Head>
      <HeaderTemplate links={ambassadorLinks} addClass="bg-white" />

      <main role="main">
        {isBreakpoint ? (
          <>
            <AmbassadorMobileTemplate />
          </>
        ) : (
          <>
            <AmbassadorDesktopTemplate />
          </>
        )}
      </main>
    </>
  );
};
export default AmbassadorPaAge;
